import { render } from "./WithdrawalTimer.vue?vue&type=template&id=3eec8c68&scoped=true"
import script from "./WithdrawalTimer.vue?vue&type=script&lang=js"
export * from "./WithdrawalTimer.vue?vue&type=script&lang=js"

import "./WithdrawalTimer.vue?vue&type=style&index=0&id=3eec8c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eec8c68"]])

export default __exports__